import { isRelation } from '@contember/schema-utils';
export const isElementFieldArgs = (args) => 'formName' in args;
export const isSortElementFormFieldArgs = (args) => 'formName' in args;
export const isSortElementDetailFieldArgs = (args) => 'detailName' in args;
export const isSortElementPreviewFieldArgs = (args) => 'previewName' in args;
export const isSelectField = (field) => 'optionField' in field;
const baseTypes = ['text', 'number', 'date', 'datetime', 'plugin'];
const extendedFieldTypes = ['select', 'multiselect', 'repeater', 'radio', 'checkbox', 'textarea'];
const fieldTypeSet = new Set([...baseTypes, ...extendedFieldTypes]);
export const isStructureFieldType = (type) => fieldTypeSet.has(type);
const extendedColumnTypes = ['hasOne', 'hasMany', 'boolean'];
const columnTypeSet = new Set([...baseTypes, ...extendedColumnTypes]);
export const isStructureColumnType = (type) => columnTypeSet.has(type);
export const hasCreateNewForm = (field) => 'createNewForm' in field;
export const hasOptionField = (field) => 'optionField' in field;
export const isRelationField = (field) => isRelation(field.modelField);
//# sourceMappingURL=helpers.js.map